import { render, staticRenderFns } from "./right-fourth-content.vue?vue&type=template&id=b7bc1918&scoped=true&"
import script from "./right-fourth-content.vue?vue&type=script&lang=js&"
export * from "./right-fourth-content.vue?vue&type=script&lang=js&"
import style0 from "./right-fourth-content.vue?vue&type=style&index=0&id=b7bc1918&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bc1918",
  null
  
)

export default component.exports